import { render, staticRenderFns } from "./BaseTermAndCondition.vue?vue&type=template&id=27432cc1&scoped=true"
import script from "./BaseTermAndCondition.vue?vue&type=script&lang=js"
export * from "./BaseTermAndCondition.vue?vue&type=script&lang=js"
import style0 from "./BaseTermAndCondition.vue?vue&type=style&index=0&id=27432cc1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27432cc1",
  null
  
)

export default component.exports